import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["message"]
  static values = { path: String, signedStreamName: String }

  connect() {
    const observer = new MutationObserver(mutationsList => {
      for (const mutation of mutationsList) {
        if (mutation.type === "attributes" && mutation.attributeName === "connected") {
          observer.disconnect()
          this.messageTarget.textContent = "Sending request..."
          fetch(this.pathValue, {
            headers: {
              Accept: "application/prs.async-html"
            }
          }).then(response => {
            if (response.status === 204) {
              this.messageTarget.textContent = "Loading..."
            } else {
              this.messageTarget.textContent = "Unexpected response"
              throw new Error(`Async content request ${this.pathValue} failed with status ${response.status}.`)
            }
          })
        }
      }
    })

    const turboCableStreamSource = document.createElement("turbo-cable-stream-source")
    turboCableStreamSource.setAttribute("channel", "Turbo::StreamsChannel")
    turboCableStreamSource.setAttribute("signed-stream-name", this.signedStreamNameValue)

    observer.observe(turboCableStreamSource, { attributes: true })
    this.element.appendChild(turboCableStreamSource)
  }
}
